module.exports = __webpack_public_path__ + "img/thirdCompany.058e34c3.png";